<script lang="ts">
import { VNode, CreateElement } from 'vue';
import { defineComponent } from '@vue/composition-api';

/** Similar to <keep-alive /> but for arrays of components */
export default defineComponent({
  name: 'BaseKeepAlive',
  data() {
    return {
      keepAliveCache: {} as Record<string, VNode>,
    };
  },
  render(createElement: CreateElement): VNode {
    const slots = (this.$slots && this.$slots.default) || [];

    for (const vnode of slots as VNode[]) {
      const key = vnode.key as string;

      if (this.keepAliveCache[key]) {
        vnode.componentInstance = this.keepAliveCache[key].componentInstance;
      } else {
        this.keepAliveCache[key] = vnode;
      }

      if (vnode.data) {
        vnode.data.keepAlive = true;
      }
    }

    return createElement('div', { class: 'base-keep-alive' }, slots);
  },
});
</script>
